import { Component, Vue, Prop } from 'vue-property-decorator'
import { IMatchup, IPick } from '@/store/modules/game/interfaces'
import MatchupStats from './MatchupStats'
import { FormatEventName, FormatEventDate, GetSeasonFromYear } from '@/utils/GameUtils'
import { IMatchupType } from './Matchup';

@Component
export default class HeadToHeadClassic extends Vue implements IMatchupType {
  @Prop() matchup: IMatchup

  private selectClick(pick: IPick) {
    const selected = this.$store.getters.HAS_SELECTION(pick.matchupId, pick.player.id) 
    if (selected) {
      // @ts-ignore
      this.$parent.removeClick(this.matchup, pick, 'h2h')
    } else {
      // @ts-ignore
      this.$parent.selectClick(this.matchup, pick, 'h2h')
    }
  }

  private render(h: any): any {
    const picks: IPick[] = [this.matchup.pickA, this.matchup.pickB]

    const pickList = picks.map((pick, idx) => { 
      const selected = this.$store.getters.HAS_SELECTION(pick.matchupId, pick.player.id) ? 'active' : ''
      const year = pick.player.name.substr(-4)
      // @ts-ignore
      const imgSrc = this.$parent.expandAssetUrl(pick.player.tags) || '/white.jpg'
      return (
        <div class={idx === 1 ? `avatar right ${selected}` : `avatar ${selected}`} onClick={this.selectClick.bind(this, pick)}>
          <img class='avatar-portrait' height='60' width='60' src={imgSrc} onError={(e: any)=>{e.target.onerror = null; e.target.src='/white.jpg'}}></img>
          <span class='avatar-position'>{pick.player.position}</span>

          <p class='avatar-name'>{pick.player.shortName.slice(0, -5)} {GetSeasonFromYear(year)}</p>
          <p class='avatar-event-name'>{(pick.player.team || '').slice(0, -5)}</p>

          <p class='avatar-fppg'>
            <span class='avatar-fppg-stat'>{pick.player.fppg}</span>
            <span class='avatar-fppg-label'>Avg fantasy points {GetSeasonFromYear(year)}</span>
          </p>
        </div>
      )
    });
    
    // @ts-ignore
    //const stats = <MatchupStats matchup={this.matchup}></MatchupStats>
    const isPersonal = this.matchup.tags.includes('cohort:personal')

    return (
      <div class={`avatar-card id-${this.matchup.id} ${isPersonal ? 'personal' : 'all'}`}>
        {pickList}
        <div class='avatar-card-div'>
          <div class='avatar-card-vs'>vs</div>
        </div>
    </div>
    );
  }
}
